export default "../../src/img/lysiq-logo-simplified-2.svg";